// Build-in
import React from "react";

// External
import { Spinner } from "react-bootstrap";
import { injectIntl } from "react-intl";

// Styles
import "./index.scss";

const Loader = ({ intl, ...props }) => {
  const { className, message, globalWrap } = props;
  return (
    <>
      {globalWrap ? (
        <div className="fade modal-backdrop show custom-zindex">
          <div className="downloadmsg">
            <div className="downloadloader"></div>
            <div className="downloadloadertext">
              {message ? message : ""}
              <br />
              {intl.formatMessage({ id: "page.loading.label" })}...
            </div>
          </div>
        </div>
      ) : (
        <div
          className={`d-flex justify-content-center ${
            className ? className : "py-5"
          }`}
        >
          <Spinner animation="border" role="status" variant="custom">
            <span className="sr-only">{message}</span>
          </Spinner>
          <strong className="ml-3 fs-18">
            {typeof message === "undefined"
              ? intl.formatMessage({ id: "page.loading.label" })
              : message}
          </strong>
        </div>
      )}
    </>
  );
};

export default injectIntl(Loader);
